// extracted by mini-css-extract-plugin
module.exports = {"row":"TextFlyout_row__3ORMD","size":"TextFlyout_size__3LxW8","font":"TextFlyout_font__10Y51"};